var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForecastMarketPriceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 72,
    viewBox: "0 0 87 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4196_6431)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4196_6431",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 83,
    height: 67
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.51172 2H84.4867V68.1272H2.51172V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4196_6431)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.5129 65.4826H58.0407V44.3227H81.8338V64.1589C81.8338 64.8879 81.242 65.4826 80.5129 65.4826ZM5.16521 64.1589V44.3227H28.9583V65.4826H6.48896C5.7599 65.4826 5.16521 64.8879 5.16521 64.1589ZM6.48896 4.64463H28.9583V12.5814H5.16521V5.96838C5.16521 5.23932 5.7599 4.64463 6.48896 4.64463ZM58.0407 15.226H81.8338V41.6781H58.0407V15.226ZM31.603 12.5814V4.64463H55.3961V12.5814H31.603ZM28.9583 41.6781H5.16521V15.226H28.9583V41.6781ZM55.3961 44.3227V65.4826H31.603V44.3227H55.3961ZM31.603 41.6781V15.226H55.3961V41.6781H31.603ZM81.8338 5.96838V12.5814H58.0407V4.64463H80.5129C81.242 4.64463 81.8338 5.23932 81.8338 5.96838ZM80.5129 2H6.48896C4.29891 2 2.52344 3.77834 2.52344 5.96838V64.1589C2.52344 66.3518 4.29891 68.1272 6.48896 68.1272H80.5129C82.703 68.1272 84.4784 66.3518 84.4784 64.1589V5.96838C84.4784 3.77834 82.703 2 80.5129 2Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0287 7.28906H13.0977V9.93655H21.0287V7.28906Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5332 7.28906V9.93655H47.4642V7.28906H39.5332Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9037 9.93655V7.28906H65.9727V9.93655H73.9037Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5 31.0952C41.3128 31.0952 39.5345 29.3168 39.5345 27.1268C39.5345 24.9367 41.3128 23.1584 43.5 23.1584C45.69 23.1584 47.4655 24.9367 47.4655 27.1268C47.4655 29.3168 45.69 31.0952 43.5 31.0952ZM52.7548 28.4505V25.8059H49.9757C49.8042 24.9625 49.4697 24.1819 49.0094 23.4843L52.3659 20.1278L50.4961 18.258L47.1424 21.6145C46.4448 21.1542 45.6643 20.8197 44.8237 20.6481V17.8691H42.1791V20.6481C41.3385 20.8197 40.558 21.1542 39.8604 21.6145L36.5038 18.258L34.634 20.1278L37.9906 23.4843C37.5331 24.1819 37.1957 24.9625 37.0271 25.8059H34.248V28.4505H37.0271C37.1957 29.2911 37.5331 30.0716 37.9906 30.7692L34.634 34.1286L36.5038 35.9984L39.8604 32.6391C40.558 33.0994 41.3385 33.4339 42.1791 33.6054V36.3844H44.8237V33.6054C45.6643 33.4339 46.4448 33.0994 47.1424 32.6391L50.4961 35.9984L52.3659 34.1286L49.0094 30.7692C49.4697 30.0716 49.8042 29.2911 49.9757 28.4505H52.7548Z",
    fill: "#FBBA0D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M34.248 60.1927V62.8373H36.8927C38.3479 62.8373 39.5345 61.648 39.5345 60.1927V57.5481C39.5345 57.062 39.3944 56.616 39.1685 56.2243C39.3944 55.8326 39.5345 55.3866 39.5345 54.9006V52.256C39.5345 50.8007 38.3479 49.6113 36.8927 49.6113H34.248V52.256H36.8927V54.9006H34.248V57.5481H36.8927V60.1927H34.248Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9015 49.6113H71.2598V52.256H73.9015V54.9006H71.2598V57.5481H73.9015V60.1927H71.2598V62.8373H73.9015C75.3597 62.8373 76.5462 61.648 76.5462 60.1927V57.5481C76.5462 57.062 76.4061 56.616 76.1802 56.2243C76.4061 55.8326 76.5462 55.3866 76.5462 54.9006V52.256C76.5462 50.8007 75.3597 49.6113 73.9015 49.6113Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8224 62.8373H47.4641V52.256C47.4641 50.8007 46.2776 49.6113 44.8224 49.6113H42.1777V52.256H44.8224V62.8373Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0285 49.6113H18.3867V52.256H21.0285V62.8373H23.6731V52.256C23.6731 50.8007 22.4866 49.6113 21.0285 49.6113Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4303 49.6114C52.1593 49.6114 52.754 49.0167 52.754 48.2877C52.754 47.5615 52.1593 46.9668 51.4303 46.9668C50.7041 46.9668 50.1094 47.5615 50.1094 48.2877C50.1094 49.0167 50.7041 49.6114 51.4303 49.6114Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9928 46.9668C24.2666 46.9668 23.6719 47.5615 23.6719 48.2877C23.6719 49.0167 24.2666 49.6114 24.9928 49.6114C25.7218 49.6114 26.3165 49.0167 26.3165 48.2877C26.3165 47.5615 25.7218 46.9668 24.9928 46.9668Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.142 24.5193L13.014 24.3849L13.2313 23.5272C13.6716 21.7546 15.247 20.5138 17.0625 20.5138C18.8808 20.5138 20.4562 21.7546 20.8936 23.5272L21.108 24.3849L21.9858 24.5193C22.9664 24.6623 23.6726 25.4828 23.6726 26.4663C23.6726 27.5614 22.7835 28.4505 21.6913 28.4505H12.4365C11.3415 28.4505 10.4552 27.5614 10.4552 26.4663C10.4552 25.4828 11.1671 24.6623 12.142 24.5193ZM12.4365 31.0952H21.6913C24.2416 31.0952 26.3173 29.0166 26.3173 26.4663C26.3173 24.4564 25.0507 22.7353 23.218 22.1063C22.2488 19.5731 19.8215 17.8691 17.0625 17.8691C14.3063 17.8691 11.879 19.5731 10.9098 22.1063C9.07425 22.7353 7.81055 24.4564 7.81055 26.4663C7.81055 29.0166 9.88623 31.0952 12.4365 31.0952Z",
    fill: "#CDEAEC"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4531 39.0315H13.0949V33.7422H10.4531V39.0315Z",
    fill: "#9DB1B6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7422 39.0315H18.3868V33.7422H15.7422V39.0315Z",
    fill: "#9DB1B6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0254 39.0315H23.67V33.7422H21.0254V39.0315Z",
    fill: "#9DB1B6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7761 49.6113C9.58602 49.6113 7.81055 51.3897 7.81055 53.5797V54.9006H10.4552V53.5797C10.4552 52.8506 11.047 52.256 11.7761 52.256C12.5051 52.256 13.097 52.8506 13.097 53.5797V53.8056C13.097 54.1572 12.9597 54.4946 12.711 54.7405L7.81055 59.6438V62.8373H15.7416V60.1927H11.0013L14.5808 56.6103C15.3299 55.8612 15.7416 54.8663 15.7416 53.8056V53.5797C15.7416 51.3897 13.9661 49.6113 11.7761 49.6113Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8678 46.9668C77.1416 46.9668 76.5469 47.5615 76.5469 48.2877C76.5469 49.0167 77.1416 49.6114 77.8678 49.6114C78.5968 49.6114 79.1915 49.0167 79.1915 48.2877C79.1915 47.5615 78.5968 46.9668 77.8678 46.9668Z",
    fill: "white"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6511 49.6113C62.461 49.6113 60.6855 51.3897 60.6855 53.5797V54.9006H63.3273V53.5797C63.3273 52.8506 63.922 52.256 64.6511 52.256C65.3773 52.256 65.972 52.8506 65.972 53.5797V53.8056C65.972 54.1572 65.8319 54.4946 65.586 54.7405L60.6855 59.6438V62.8373H68.6166V60.1927H63.8763L67.4529 56.6103C68.202 55.8612 68.6166 54.8663 68.6166 53.8056V53.5797C68.6166 51.3897 66.8411 49.6113 64.6511 49.6113Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5634 33.7398H65.3115C64.2165 33.7398 63.3273 32.8506 63.3273 31.7556C63.3273 30.7749 64.0364 29.9544 65.017 29.8086L65.8948 29.6742L66.1063 28.8165C66.5466 27.0439 68.1191 25.8059 69.9375 25.8059C71.7558 25.8059 73.3312 27.0439 73.7686 28.8165L73.9802 29.6742L74.8579 29.8086C75.8386 29.9544 76.5476 30.7749 76.5476 31.7556C76.5476 32.8506 75.6585 33.7398 74.5634 33.7398ZM65.972 20.5138C67.4272 20.5138 68.6166 21.7031 68.6166 23.1584C68.6166 23.2099 68.6051 23.2613 68.5994 23.3157C67.1356 23.6187 65.829 24.4107 64.8826 25.54C63.9649 25.1226 63.3273 24.202 63.3273 23.1584C63.3273 21.7031 64.5167 20.5138 65.972 20.5138ZM76.093 27.3955C75.2782 25.277 73.4398 23.7531 71.2441 23.3042C71.2498 23.2585 71.2612 23.207 71.2612 23.1584C71.2612 20.2393 68.8911 17.8691 65.972 17.8691C63.0557 17.8691 60.6855 20.2393 60.6855 23.1584C60.6855 25.0282 61.7034 26.7036 63.2244 27.6386C61.6977 28.4019 60.6855 29.9573 60.6855 31.7556C60.6855 34.3087 62.7612 36.3844 65.3115 36.3844H74.5634C77.1166 36.3844 79.1923 34.3087 79.1923 31.7556C79.1923 29.7457 77.9257 28.0274 76.093 27.3955Z",
    fill: "url(#paint0_linear_4196_6431)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4196_6431",
    x: 0.122449,
    y: 0.199259,
    width: 86.7571,
    height: 70.9289,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.600247
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.20049
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.419608 0 0 0 0 0.262745 0 0 0 0 0.211765 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4196_6431"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4196_6431",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4196_6431",
    x1: 69.9389,
    y1: 36.3844,
    x2: 69.9389,
    y2: 17.8691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBB00B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D2E0E3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForecastMarketPriceIcon);
export default __webpack_public_path__ + "static/media/forecast_market_price_icon.8db7e9cbdd3223ca1cdc1a134c5df773.svg";
export { ForwardRef as ReactComponent };